import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { Checkbox, CircularProgress } from "@mui/material";
import ShareVideo from "../videoPlayer/Content/ShareVideo";
import { FaPlusSquare, FaMinusSquare } from "react-icons/fa";
import { BsSquare, BsCheckSquare } from "react-icons/bs";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import styles from "./video-highlight.module.css";
import {
  checkUnCheckSelectedVideo,
  fetchAllSeasonData,
} from "../../../Redux/Actions/VideoLibraryActions";
import {
  setSelectedVideoPath,
  setIsOverlayText,
  setShowSlider,
  setEditIcons,
  setShowSelectionToolkit,
  setShowToolkit,
  setShowToolkitSecond,
  setPlaylistData,
} from "../../../Redux/Actions/VideoHighlightAction";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import { convertM3u8ToMp4 } from "../../../utils/m3u8ToMp4Url";
import { eventConstants } from "../../../utils/constant";

export default function ControlledAccordions({
  playVideo,
  isPlaylistSelected,
  playSelectedVideo,
  allVideos,
  intercutPlaylist,
  setVideoPath,
  videoPath,
}) {
  const {
    InSeason,
    Game,
    Practice,
    OpponentScout,
    OffSeason,
    Other,
    highlight,
    inSeason,
    offSeason,
    other,
    game,
    smallPractice,
    opponentScout,
  } = eventConstants;
  const schoolId = getFromLocalStorage("schoolId");
  const [expanded, setExpanded] = useState(false);
  const [subExpanded, setSubExpanded] = useState(false);
  const [eventExpanded, setEventExpanded] = useState(false);
  const [weekExpanded, setWeekExpanded] = useState(false);
  const [typeExpanded, setTypeExpanded] = useState(false);
  const [expandedPlaylist, setExpandedPlaylist] = useState(false);
  const [eventNameExpanded, setEventNameExpanded] = useState(false);
  const [otherSeasonTypeExpanded, setOtherSeasonTypeExpanded] = useState(false);
  const [practiceExpanded, setPracticeExpanded] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [playlistMedias, setPlaylistMedias] = useState([]);
  const [playlistId, setPlaylistId] = useState();
  const [eventId, setEventId] = useState();
  const [checkedMedia, setCheckedMedia] = useState([]);
  const [errorEvents, setErrorEvents] = useState();
  const [fetchingEvents, setFetchingEvents] = useState(false);
  const [errorPlaylist, setErrorPlaylist] = useState();
  const [fetchingPlaylist, setFetchingPlaylist] = useState(false);
  const [inSeasonData, setInSeasonData] = useState([]);
  const [offSeasonData, setOffSeasonData] = useState([]);
  const [otherSeasonData, setOtherSeasonData] = useState([]);
  const [loadPlaylist, setLoadPlaylist] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const seasonId = urlParams.get("season-year");
  const evId = urlParams.get("season-type");
  const weekId = urlParams.get("week");
  const off_season_eventName = urlParams.get("eventname");
  const practice = urlParams.get("practice");
  const eventType = urlParams.get("event-type");
  const mdId = urlParams.get("mediaId");
  const fetchedSeasonData = useSelector(
    (state) => state.videoLibraryData?.fetchedSeasonData?.allSeasonData,
    shallowEqual
  );
  const isLoading = useSelector(
    (state) => state.videoLibraryData?.fetchedSeasonData?.loading
  );
  const { selectedVideoPaths, playlistsData } = useSelector(
    (state) => state.videoHighlightData
  );
  const dispatch = useDispatch();
  useEffect(() => {
    fetchScheduleList();
  }, []);

  const fetchScheduleList = () => {
    fetchAllSeasonData(dispatch, schoolId);
    if (seasonId !== undefined) {
      notificationNavigation();
    }
  };
  const handleCheckBoxChange = (checked, videoData) => {
    setShowToolkit(dispatch, false);
    setShowToolkitSecond(dispatch, false);
    setShowSelectionToolkit(dispatch, false);
    setEditIcons(dispatch, false);
    setShowSlider(dispatch, false);
    setIsOverlayText(dispatch, false);
    let { videoPath, videoDuration, eventMediaCategory } = videoData;
    let mp4Path;
    if (videoPath?.endsWith(".m3u8")) {
      mp4Path = convertM3u8ToMp4(videoPath);
    } else {
      mp4Path = videoPath;
    }
    const data = {
      ...videoData,
      path: videoPath,
      videoName: eventMediaCategory,
      schoolId,
      startTime: "",
      duration: "",
      text: "",
      mp4Path,
      videoDuration,
    };
    if (checked) {
      setSelectedVideoPath(dispatch, [...selectedVideoPaths, data]);
    } else {
      if (data.path == videoPath) {
        setVideoPath("");
      }
      const updatedSelectedVideoPaths = selectedVideoPaths.filter(
        (temp) => temp.path != data.path
      );
      setSelectedVideoPath(dispatch, updatedSelectedVideoPaths);
    }
  };

  const handlePlaylistChange =
    ({ playlistId, year }) =>
    async () => {
      if (expandedPlaylist === playlistId) {
        // Collapse if already expanded
        setExpandedPlaylist(null);
      } else {
        setLoadPlaylist(`${playlistId}/playlist`);
        setExpandedPlaylist(playlistId);
        // Only fetch videos if they haven't been fetched already
        if (!playlistsData[playlistId]?.media) {
          await fetchVideosForPlaylist({ playlistId, year });
        }
        setLoadPlaylist("");
      }
      setPlaylistId(playlistId);
    };

  const fetchVideosForPlaylist = async ({ playlistId, year }) => {
    try {
      const res = await userService.getAllMediaByPlaylist(
        schoolId,
        year,
        playlistId
      );
      let data = res.data.data?.mediaBreakdownDetails.map(
        (ele) => ele?.eventMedia
      );
      const highlights = data.filter((video) => video.isEdited === true);
      const media = data.filter((video) => video.isEdited === false);
      setPlaylistData(dispatch, {
        media: media,
        highlights: highlights,
        playlistId: playlistId,
      });
    } catch (error) {
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    }
  };

  const setVideoName = ({
    seasonType,
    eventType,
    weekName,
    offSeasonEventName,
    practiceName,
    otherSeasonEventType,
    videoId,
    newVideoName,
    isVideoRenamed,
  }) => {
    switch (seasonType) {
      case "in-season":
        let inSeason = [...inSeasonData];
        const uploadedVideosIndex = inSeason.findIndex(
          (x) => x.weekName === weekName
        );
        if (isVideoRenamed) {
          inSeason[uploadedVideosIndex][eventType].map((item) => {
            if (item.id === videoId) {
              item.eventMediaCategory = newVideoName + ".mp4";
            }
          });
        } else {
          let inSeasonVideoRemoved = inSeason[uploadedVideosIndex][
            eventType
          ].filter((data) => {
            return data.id !== videoId;
          });

          inSeason[uploadedVideosIndex][eventType] = inSeasonVideoRemoved;
        }
        setInSeasonData(inSeason);
        break;

      case "off-season":
        let offSeason = [...offSeasonData];
        const eventIndex = offSeason.findIndex(
          (x) => x.eventName === offSeasonEventName
        );
        offSeason[eventIndex].arr.map((item) => {
          if (item.practiceName === practiceName) {
            if (isVideoRenamed) {
              item.practiceArray.map((data) => {
                if (data.id === videoId) {
                  data.eventMediaCategory = newVideoName + ".mp4";
                }
              });
            } else {
              const offSeasonVideoRemoved = item.practiceArray.filter(
                (element) => {
                  return element.id !== videoId;
                }
              );
              item.practiceArray = offSeasonVideoRemoved;
            }
          }
        });

        setOffSeasonData(offSeason);
        break;

      case "other":
        let otherSeason = [...otherSeasonData];

        const otherSeasonTypeIndex = otherSeason.findIndex(
          (x) => x.seasonType === otherSeasonEventType
        );

        if (isVideoRenamed) {
          otherSeason[otherSeasonTypeIndex].arrData.map((item) => {
            if (item.id === videoId) {
              item.eventMediaCategory = newVideoName + ".mp4";
            }
          });
        } else {
          const otherSeasonVideoRenamed = otherSeason[
            otherSeasonTypeIndex
          ].arrData.filter((data) => {
            return data.id !== videoId;
          });
          otherSeason[otherSeasonTypeIndex].arrData = otherSeasonVideoRenamed;
        }

        setOtherSeasonData(otherSeason);

      default:
        break;
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setSubExpanded(false);
  };

  const subhandleChange = (panel) => (event, isExpanded) => {
    setSubExpanded(isExpanded ? panel : false);
  };

  const handleEventChange = (panel) => (event, isExpanded) => {
    setEventExpanded(isExpanded ? panel : false);
  };

  const handleWeekChange = (panel) => (event, isExpanded) => {
    setWeekExpanded(isExpanded ? panel : false);
  };

  const handleEventNameChange = (panel) => (event, isExpanded) => {
    setEventNameExpanded(isExpanded ? panel : false);
  };

  const handleTypeChange = (panel) => (event, isExpanded) => {
    setTypeExpanded(isExpanded ? panel : false);
  };

  const handleOtherSeasonTypeChange = (panel) => (event, isExpanded) => {
    setOtherSeasonTypeExpanded(isExpanded ? panel : false);
  };

  const handlePracticeNameChange = (panel) => (event, isExpanded) => {
    setPracticeExpanded(isExpanded ? panel : false);
  };

  const eventPlaylist = async (playlistID, status, seasonName, seasonType) => {
    checkUnCheckSelectedVideo(dispatch, {
      playlistID,
      status,
      seasonType: seasonType,
      seasonName,
    });
  };

  useEffect(() => {
    return () => {
      setShowToolkit(dispatch, false);
      setShowToolkitSecond(dispatch, false);
      setShowSelectionToolkit(dispatch, false);
      setEditIcons(dispatch, false);
      setShowSlider(dispatch, false);
      setIsOverlayText(dispatch, false);
      setErrorPlaylist("");
    };
  }, []);

  const fetchEvents = () => {
    return userService.getAllEvents(schoolId);
  };

  const checkPaymentStatus = () => {
    userService.getBillingDetailsCheck(schoolId).then((res) => {
      const check = res.data.status;
      if (check == false) {
        fetchEvents()
          .then((res) => {
            setErrorEvents("");
            setFetchingEvents(true);
            const { data } = res;
            setFetchingEvents(false);
            const events = [...data.data.events];
            events.map((ele) => {
              if (ele.playlists.Game) {
                ele.playlists.Game.map((el) => {
                  el.checked = false;
                  return el;
                });
              }
              if (ele.playlists.Practice) {
                ele.playlists.Practice.map((el) => {
                  el.checked = false;
                  return el;
                });
              }
              if (ele.playlists.Scout) {
                ele.playlists.Scout.map((el) => {
                  el.checked = false;
                  return el;
                });
              }
            });
            setEventList(events);
          })
          .catch((error) => {
            setErrorEvents(error.message);
            setFetchingEvents(false);
          });
      }
    });
  };

  useEffect(() => {
    checkPaymentStatus();
  }, []);

  const notificationNavigation = () => {
    setExpanded(seasonId);
    setEventExpanded(evId);
    setWeekExpanded(weekId?.toString());
    setEventNameExpanded(off_season_eventName);
    setPracticeExpanded(practice);
    setOtherSeasonTypeExpanded(eventType);
    setTypeExpanded(eventType);
  };

  const checkUnCheckVideo = (id) => {
    allVideos.map((media) => {
      if (media.id == id) {
        media.checked = true;
        playVideo(media.videoPath, media.id);
        return media;
      } else {
        media.checked = false;
        return media;
      }
    });
    const checkedPlaylistMedias = playlistMedias.filter(
      (el) => el.checked === true && el
    );
    setCheckedMedia(checkedPlaylistMedias);
  };

  useEffect(() => {
    checkUnCheckVideo(mdId);
  }, [mdId, playlistMedias.length]);

  const playEditedVideo = (editedVideoPath) => {
    playSelectedVideo(editedVideoPath, eventId);
  };

  const sortArrayOfObject = (list) => {
    let newSortedData = [];
    if (list) {
      newSortedData = list?.sort((a, b) => parseInt(a?.id) - parseInt(b?.id));
    } else {
      newSortedData = [];
    }
    return newSortedData;
  };

  return (
    <div className="allEventsContainer">
      {errorEvents && <div className="apiError">{errorEvents}</div>}
      {isLoading && (
        <div className="circularLoading">
          <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
            <CircularProgress
              className="rounded-circle"
              color="success"
              sx={{ fontSize: 10, color: "#002244" }}
              disableShrink
            />
          </div>
        </div>
      )}
      {!isLoading && fetchedSeasonData?.length === 0 && (
        <div className="circularLoading">No Records Found</div>
      )}
      {!isLoading && fetchedSeasonData?.length > 0 && (
        <div>
          <div>
            {fetchedSeasonData?.map((season, index) => (
              <Accordion
                className="eventsWrapper accordion-container-border"
                expanded={expanded === season.seasonName}
                onChange={handleChange(season.seasonName)}
                key={season.seasonName + index}
                sx={{ cursor: "pointer" }}
              >
                <AccordionSummary
                  className="season-name-accordion"
                  sx={{ cursor: "pointer !important" }}
                >
                  <Typography
                    sx={{
                      width: "33%",
                      flexShrink: 0,
                      cursor: "pointer !important",
                    }}
                    className="eventText"
                  >
                    <div className="d-flex-align-cent">
                      {expanded === season.seasonName ? (
                        <FaMinusSquare
                          className="mg-right-10"
                          style={{ color: "#13005A" }}
                        />
                      ) : (
                        <FaPlusSquare
                          className="mg-right-10"
                          style={{ color: "#13005A" }}
                        />
                      )}
                      {season.seasonName.replaceAll("-", " - ")}
                    </div>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  className="mg-top-min-10 accordion-details w-100"
                  sx={{ cursor: "pointer !important" }}
                >
                  <Typography>
                    <Accordion
                      expanded={eventExpanded === InSeason}
                      onChange={handleEventChange(InSeason)}
                      className="subEvents accordion-container-border"
                      sx={{ cursor: "pointer !important" }}
                    >
                      <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        className="subEventsSummary"
                        sx={{ cursor: "pointer !important" }}
                      >
                        <div className="d-flex-align-cent">
                          {eventExpanded === InSeason ? (
                            <FaMinusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          ) : (
                            <FaPlusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          )}
                          In-Season
                        </div>
                      </AccordionSummary>
                      <AccordionDetails sx={{ cursor: "pointer !important" }}>
                        <Typography
                          sx={{
                            width: "33%",
                            flexShrink: 0,
                            cursor: "pointer !important",
                          }}
                          className="mg-top-min-20 eventText w-100"
                        >
                          {season?.inSeasonPlaylist?.map((item, index) => (
                            <Accordion
                              expanded={
                                weekExpanded ===
                                item.weekName.replaceAll("-", " - ")
                              }
                              onChange={handleWeekChange(
                                item.weekName.replaceAll("-", " - ")
                              )}
                              className="eventsWrapper w-100 accordion-container-border"
                              key={item.weekName.replaceAll("-", " - ") + index}
                              sx={{ cursor: "pointer !important" }}
                            >
                              <AccordionSummary
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className="subEventsSummary"
                                sx={{ cursor: "pointer !important" }}
                              >
                                <div className="d-flex-align-cent w-100">
                                  {weekExpanded ===
                                  item.weekName.replaceAll("-", " - ") ? (
                                    <FaMinusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  ) : (
                                    <FaPlusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  )}
                                  <div className="oflow-hidden w-100">
                                    <p className="text-width-auto">
                                      {item.weekName.replaceAll("-", " - ")}
                                    </p>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails
                                sx={{ cursor: "pointer !important" }}
                              >
                                <Typography
                                  className="mg-top-min-20"
                                  sx={{ cursor: "pointer !important" }}
                                >
                                  {/* Game Playlist */}
                                  <Accordion
                                    expanded={typeExpanded === Game}
                                    onChange={handleTypeChange(Game)}
                                    className="subEvents accordion-container-border"
                                    sx={{ cursor: "pointer !important" }}
                                  >
                                    <AccordionSummary
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                      className="subEventsSummary"
                                      sx={{ cursor: "pointer !important" }}
                                    >
                                      <div className="d-flex-align-cent">
                                        {expandedPlaylist === Game ? (
                                          <FaMinusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        ) : (
                                          <FaPlusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        )}
                                        {`Game (${
                                          item?.gamePlaylist?.length || 0
                                        })`}
                                      </div>
                                    </AccordionSummary>
                                    <AccordionDetails className="pd-left-10">
                                      <div className="d-flex flex-direction-c">
                                        {item?.gamePlaylist.length > 0 ? (
                                          sortArrayOfObject(
                                            item.gamePlaylist
                                          )?.map((playlist, key) => (
                                            <Accordion
                                              key={key}
                                              expanded={
                                                expandedPlaylist === playlist.id
                                              }
                                              onChange={handlePlaylistChange({
                                                playlistId: playlist.id,
                                                year: season.seasonName,
                                              })}
                                              className="playlistAccordion"
                                            >
                                              <AccordionSummary
                                                aria-controls={`panel${key}-content`}
                                                id={`panel${key}-header`}
                                              >
                                                <div className="d-flex-align-cent">
                                                  {expandedPlaylist ===
                                                  playlist.id ? (
                                                    <FaMinusSquare
                                                      className="mg-right-10"
                                                      style={{
                                                        color: "#13005A",
                                                      }}
                                                    />
                                                  ) : (
                                                    <FaPlusSquare
                                                      className="mg-right-10"
                                                      style={{
                                                        color: "#13005A",
                                                      }}
                                                    />
                                                  )}
                                                  {playlist.playlistName}
                                                </div>
                                              </AccordionSummary>
                                              {loadPlaylist && (
                                                <div
                                                  className={
                                                    styles.circularLoading
                                                  }
                                                >
                                                  <CircularProgress
                                                    sx={{
                                                      fontSize: "10",
                                                      color: "#002244",
                                                    }}
                                                    disableShrink
                                                  />
                                                </div>
                                              )}
                                              <AccordionDetails className="pd-left-10">
                                                <div className="d-flex flex-direction-c">
                                                  {sortArrayOfObject(
                                                    playlistsData[playlist?.id]
                                                      ?.media
                                                  )?.map((video, videoKey) => (
                                                    <div
                                                      className="d-flex-space-between w-100 gap-5"
                                                      key={video.id}
                                                    >
                                                      <div className="d-flex-align-cent gap-10">
                                                        <Checkbox
                                                          key={videoKey}
                                                          name={
                                                            video.eventMediaCategory
                                                          }
                                                          checked={selectedVideoPaths.some(
                                                            (data) =>
                                                              data?.path ===
                                                              video?.videoPath
                                                          )}
                                                          onChange={(e) =>
                                                            handleCheckBoxChange(
                                                              e.target.checked,
                                                              {
                                                                id: video.id,
                                                                year: season.seasonName,
                                                                playListId:
                                                                  playlist.id,
                                                                ...video,
                                                                seasonType:
                                                                  InSeason,
                                                                eventType: Game,
                                                                eventName: "",
                                                                practiceName:
                                                                  "",
                                                                weekname:
                                                                  item?.weekName,
                                                                opponentName:
                                                                  item?.weekName.split(
                                                                    "-"
                                                                  )[1],
                                                                scheduleId:
                                                                  video
                                                                    ?.scheduleEvent
                                                                    ?.schedule
                                                                    .id,
                                                                schoolId,
                                                                seasonId:
                                                                  video
                                                                    .scheduleEvent
                                                                    .season.id,
                                                              }
                                                            )
                                                          }
                                                          icon={
                                                            <BsSquare
                                                              fontSize="20px"
                                                              color="#13005A"
                                                            />
                                                          }
                                                          checkedIcon={
                                                            <BsCheckSquare
                                                              fontSize="20px"
                                                              color="#13005A"
                                                            />
                                                          }
                                                        />
                                                        <div className="oflow-hidden w-100">
                                                          <p>
                                                            {
                                                              video?.eventMediaCategory
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                      {selectedVideoPaths.some(
                                                        (data) =>
                                                          video.videoPath ==
                                                          data.path
                                                      ) && (
                                                        <ShareVideo
                                                          eventMediaId={
                                                            video.id
                                                          }
                                                          playlistId={
                                                            playlistId
                                                          }
                                                          videoPath={
                                                            video.videoPath
                                                          }
                                                          videoName={
                                                            video.eventMediaCategory
                                                          }
                                                          videoData={video}
                                                          seasonType={inSeason}
                                                          weekName={
                                                            item.weekName
                                                          }
                                                          eventType={game}
                                                          setVideoName={(
                                                            params
                                                          ) =>
                                                            setVideoName(params)
                                                          }
                                                          seasonName={
                                                            season.seasonName
                                                          }
                                                          selectedVideoPaths={
                                                            selectedVideoPaths
                                                          }
                                                          setVideoPath={
                                                            setVideoPath
                                                          }
                                                        />
                                                      )}
                                                    </div>
                                                  ))}
                                                  {playlistsData[playlist.id]
                                                    ?.media?.length === 0 && (
                                                    <p>No Videos Found</p>
                                                  )}
                                                </div>
                                              </AccordionDetails>
                                            </Accordion>
                                          ))
                                        ) : (
                                          <p>No Playlists Found</p>
                                        )}
                                      </div>
                                    </AccordionDetails>
                                  </Accordion>
                                  {/* Practice Playlist */}
                                  <Accordion
                                    expanded={typeExpanded === Practice}
                                    onChange={handleTypeChange(Practice)}
                                    className="subEvents accordion-container-border"
                                    sx={{ cursor: "pointer !important" }}
                                  >
                                    <AccordionSummary
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                      className="subEventsSummary"
                                      sx={{ cursor: "pointer !important" }}
                                    >
                                      <div className="d-flex-align-cent">
                                        {expandedPlaylist === "Practice" ? (
                                          <FaMinusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        ) : (
                                          <FaPlusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        )}
                                        {`Practice (${
                                          item?.practicePlaylist?.length || 0
                                        })`}
                                      </div>
                                    </AccordionSummary>
                                    <AccordionDetails className="pd-left-10">
                                      <div className="d-flex flex-direction-c">
                                        {item?.practicePlaylist.length > 0 ? (
                                          sortArrayOfObject(
                                            item?.practicePlaylist
                                          ).map((playlist, key) => (
                                            <Accordion
                                              key={key}
                                              expanded={
                                                expandedPlaylist === playlist.id
                                              }
                                              onChange={handlePlaylistChange({
                                                playlistId: playlist.id,
                                                year: season.seasonName,
                                              })}
                                              className="playlistAccordion"
                                            >
                                              <AccordionSummary
                                                aria-controls={`panel${key}-content`}
                                                id={`panel${key}-header`}
                                              >
                                                <div className="d-flex-align-cent">
                                                  {expandedPlaylist ===
                                                  playlist.id ? (
                                                    <FaMinusSquare
                                                      className="mg-right-10"
                                                      style={{
                                                        color: "#13005A",
                                                      }}
                                                    />
                                                  ) : (
                                                    <FaPlusSquare
                                                      className="mg-right-10"
                                                      style={{
                                                        color: "#13005A",
                                                      }}
                                                    />
                                                  )}
                                                  {playlist.playlistName}
                                                </div>
                                              </AccordionSummary>
                                              {loadPlaylist && (
                                                <div
                                                  className={
                                                    styles.circularLoading
                                                  }
                                                >
                                                  <CircularProgress
                                                    sx={{
                                                      fontSize: "10",
                                                      color: "#002244",
                                                    }}
                                                    disableShrink
                                                  />
                                                </div>
                                              )}
                                              <AccordionDetails className="pd-left-10">
                                                <div className="d-flex flex-direction-c">
                                                  {sortArrayOfObject(
                                                    playlistsData[playlist?.id]
                                                      ?.media
                                                  ).map((video, videoKey) => (
                                                    <div
                                                      className="d-flex-space-between w-100 gap-5"
                                                      key={video.id}
                                                    >
                                                      <div className="d-flex-align-cent gap-10">
                                                        <Checkbox
                                                          key={videoKey}
                                                          name={
                                                            video.eventMediaCategory
                                                          }
                                                          checked={selectedVideoPaths.some(
                                                            (data) =>
                                                              data?.path ===
                                                              video?.videoPath
                                                          )}
                                                          onChange={(e) =>
                                                            handleCheckBoxChange(
                                                              e.target.checked,
                                                              {
                                                                id: video.id,
                                                                year: season.seasonName,
                                                                playListId:
                                                                  playlist.id,
                                                                ...video,
                                                                year: season?.seasonName,
                                                                seasonType:
                                                                  InSeason,
                                                                eventType:
                                                                  Practice,
                                                                eventName: "",
                                                                practiceName:
                                                                  "",
                                                                weekname:
                                                                  item?.weekName,
                                                                opponentName:
                                                                  item?.weekName.split(
                                                                    "-"
                                                                  )[1],
                                                                scheduleId:
                                                                  video
                                                                    ?.scheduleEvent
                                                                    ?.schedule
                                                                    .id,
                                                                schoolId,
                                                                seasonId:
                                                                  video
                                                                    .scheduleEvent
                                                                    .season.id,
                                                              }
                                                            )
                                                          }
                                                          icon={
                                                            <BsSquare
                                                              fontSize="20px"
                                                              color="#13005A"
                                                            />
                                                          }
                                                          checkedIcon={
                                                            <BsCheckSquare
                                                              fontSize="20px"
                                                              color="#13005A"
                                                            />
                                                          }
                                                        />
                                                        <div className="oflow-hidden w-100">
                                                          <p>
                                                            {
                                                              video?.eventMediaCategory
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <ShareVideo
                                                        eventMediaId={video.id}
                                                        playlistId={playlistId}
                                                        videoPath={
                                                          video.videoPath
                                                        }
                                                        videoName={
                                                          video.eventMediaCategory
                                                        }
                                                        videoData={video}
                                                        seasonType={inSeason}
                                                        weekName={item.weekName}
                                                        eventType={
                                                          smallPractice
                                                        }
                                                        setVideoName={(
                                                          params
                                                        ) =>
                                                          setVideoName(params)
                                                        }
                                                        seasonName={
                                                          season.seasonName
                                                        }
                                                        selectedVideoPaths={
                                                          selectedVideoPaths
                                                        }
                                                        setVideoPath={
                                                          setVideoPath
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                  {playlistsData[playlist.id]
                                                    ?.media?.length === 0 && (
                                                    <p>No Videos Found</p>
                                                  )}
                                                </div>
                                              </AccordionDetails>
                                            </Accordion>
                                          ))
                                        ) : (
                                          <p>No Playlists Found</p>
                                        )}
                                      </div>
                                    </AccordionDetails>
                                  </Accordion>
                                  {/* Opponent Scout */}
                                  <Accordion
                                    expanded={typeExpanded === OpponentScout}
                                    onChange={handleTypeChange(OpponentScout)}
                                    className="subEvents accordion-container-border"
                                    sx={{ cursor: "pointer !important" }}
                                  >
                                    <AccordionSummary
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                      className="subEventsSummary"
                                      sx={{ cursor: "pointer !important" }}
                                    >
                                      <div className="d-flex-align-cent">
                                        {expandedPlaylist === OpponentScout ? (
                                          <FaMinusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        ) : (
                                          <FaPlusSquare
                                            className="mg-right-10"
                                            style={{ color: "#13005A" }}
                                          />
                                        )}
                                        {`Opponent Scout (${
                                          item?.opponentScoutPlaylist?.length ||
                                          0
                                        })`}
                                      </div>
                                    </AccordionSummary>
                                    <AccordionDetails className="pd-left-10">
                                      <div className="d-flex flex-direction-c">
                                        {item?.opponentScoutPlaylist?.length >
                                        0 ? (
                                          item.opponentScoutPlaylist?.map(
                                            (playlist, key) => (
                                              <Accordion
                                                key={key}
                                                expanded={
                                                  expandedPlaylist ===
                                                  playlist.id
                                                }
                                                onChange={handlePlaylistChange({
                                                  playlistId: playlist.id,
                                                  year: season.seasonName,
                                                })}
                                                className="playlistAccordion"
                                              >
                                                <AccordionSummary
                                                  aria-controls={`panel${key}-content`}
                                                  id={`panel${key}-header`}
                                                >
                                                  <div className="d-flex-align-cent">
                                                    {expandedPlaylist ===
                                                    playlist.id ? (
                                                      <FaMinusSquare
                                                        className="mg-right-10"
                                                        style={{
                                                          color: "#13005A",
                                                        }}
                                                      />
                                                    ) : (
                                                      <FaPlusSquare
                                                        className="mg-right-10"
                                                        style={{
                                                          color: "#13005A",
                                                        }}
                                                      />
                                                    )}
                                                    {playlist.playlistName}
                                                  </div>
                                                </AccordionSummary>
                                                {loadPlaylist && (
                                                  <div
                                                    className={
                                                      styles.circularLoading
                                                    }
                                                  >
                                                    <CircularProgress
                                                      sx={{
                                                        fontSize: "10",
                                                        color: "#002244",
                                                      }}
                                                      disableShrink
                                                    />
                                                  </div>
                                                )}
                                                <AccordionDetails className="pd-left-10">
                                                  <div className="d-flex flex-direction-c">
                                                    {playlistsData[
                                                      playlist?.id
                                                    ]?.media.map(
                                                      (video, videoKey) => (
                                                        <div
                                                          className="d-flex-space-between w-100 gap-5"
                                                          key={video.id}
                                                        >
                                                          <div className="d-flex-align-cent gap-10">
                                                            <Checkbox
                                                              key={videoKey}
                                                              name={
                                                                video.eventMediaCategory
                                                              }
                                                              checked={selectedVideoPaths.some(
                                                                (data) =>
                                                                  data?.path ===
                                                                  video?.videoPath
                                                              )}
                                                              onChange={(e) =>
                                                                handleCheckBoxChange(
                                                                  e.target
                                                                    .checked,
                                                                  {
                                                                    id: video.id,
                                                                    year: season.seasonName,
                                                                    playListId:
                                                                      playlist.id,
                                                                    ...video,
                                                                    year: season?.seasonName,
                                                                    seasonType:
                                                                      InSeason,
                                                                    eventType:
                                                                      OpponentScout,
                                                                    eventName:
                                                                      "",
                                                                    practiceName:
                                                                      "",
                                                                    weekname:
                                                                      item?.weekName,
                                                                    opponentName:
                                                                      item?.weekName.split(
                                                                        "-"
                                                                      )[1],
                                                                    scheduleId:
                                                                      video
                                                                        ?.scheduleEvent
                                                                        ?.schedule
                                                                        .id,
                                                                    schoolId,
                                                                    seasonId:
                                                                      video
                                                                        .scheduleEvent
                                                                        .season
                                                                        .id,
                                                                  }
                                                                )
                                                              }
                                                              icon={
                                                                <BsSquare
                                                                  fontSize="20px"
                                                                  color="#13005A"
                                                                />
                                                              }
                                                              checkedIcon={
                                                                <BsCheckSquare
                                                                  fontSize="20px"
                                                                  color="#13005A"
                                                                />
                                                              }
                                                            />
                                                            <div className="oflow-hidden w-100">
                                                              <p>
                                                                {
                                                                  video?.eventMediaCategory
                                                                }
                                                              </p>
                                                            </div>
                                                          </div>
                                                          <ShareVideo
                                                            eventMediaId={
                                                              video.id
                                                            }
                                                            playlistId={
                                                              playlistId
                                                            }
                                                            videoPath={
                                                              video.videoPath
                                                            }
                                                            videoName={
                                                              video.eventMediaCategory
                                                            }
                                                            videoData={video}
                                                            seasonType={
                                                              inSeason
                                                            }
                                                            weekName={
                                                              item.weekName
                                                            }
                                                            eventType={
                                                              opponentScout
                                                            }
                                                            setVideoName={(
                                                              params
                                                            ) =>
                                                              setVideoName(
                                                                params
                                                              )
                                                            }
                                                            seasonName={
                                                              season.seasonName
                                                            }
                                                            selectedVideoPaths={
                                                              selectedVideoPaths
                                                            }
                                                            setVideoPath={
                                                              setVideoPath
                                                            }
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                    {playlistsData[playlist.id]
                                                      ?.media?.length === 0 && (
                                                      <p>No Videos Found</p>
                                                    )}
                                                  </div>
                                                </AccordionDetails>
                                              </Accordion>
                                            )
                                          )
                                        ) : (
                                          <p>No Playlists Found</p>
                                        )}
                                      </div>
                                    </AccordionDetails>
                                  </Accordion>
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={eventExpanded === OffSeason}
                      onChange={handleEventChange(OffSeason)}
                      className="subEvents accordion-container-border"
                      sx={{ cursor: "pointer !important" }}
                    >
                      <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        className="subEventsSummary"
                        sx={{ cursor: "pointer !important" }}
                      >
                        <div className="d-flex-align-cent">
                          {eventExpanded === "Off-Season" ? (
                            <FaMinusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          ) : (
                            <FaPlusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          )}
                          Off-Season
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography
                          className="mg-top-min-20 eventText"
                          sx={{ cursor: "pointer !important" }}
                        >
                          {season?.offSeasonPlaylist?.map((event, index) => (
                            <Accordion
                              expanded={eventNameExpanded === event.eventName}
                              onChange={handleEventNameChange(event.eventName)}
                              className="eventsWrapper accordion-container-border"
                              key={index}
                              sx={{ cursor: "pointer !important" }}
                            >
                              <AccordionSummary
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className="subEventsSummary"
                                sx={{ cursor: "pointer !important" }}
                              >
                                <div className="d-flex-align-cent">
                                  {eventNameExpanded === event.eventName ? (
                                    <FaMinusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  ) : (
                                    <FaPlusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  )}
                                  {event.eventName}
                                </div>
                              </AccordionSummary>
                              <AccordionDetails
                                sx={{ cursor: "pointer !important" }}
                              >
                                <Typography className="mg-top-min-20">
                                  {event.arr.map((practice, index) => (
                                    <Accordion
                                      expanded={
                                        practiceExpanded ===
                                        practice.practiceName
                                      }
                                      onChange={handlePracticeNameChange(
                                        practice.practiceName
                                      )}
                                      className="subEvents accordion-container-border"
                                      key={index}
                                    >
                                      <AccordionSummary
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className="subEventsSummary"
                                      >
                                        <div className="d-flex-align-cent">
                                          {practiceExpanded ===
                                          practice.practiceName ? (
                                            <FaMinusSquare
                                              className="mg-right-10"
                                              style={{ color: "#13005A" }}
                                            />
                                          ) : (
                                            <FaPlusSquare
                                              className="mg-right-10"
                                              style={{ color: "#13005A" }}
                                            />
                                          )}
                                          {practice.practiceName}
                                        </div>
                                      </AccordionSummary>
                                      <AccordionDetails className="pd-left-10">
                                        <div className="d-flex flex-direction-c">
                                          {/* Loop through playlists for each practice */}
                                          {practice?.practiceArrayPlaylist
                                            ?.length > 0 ? (
                                            sortArrayOfObject(
                                              practice.practiceArrayPlaylist
                                            ).map((playlist, playlistIndex) => (
                                              <Accordion
                                                key={playlistIndex}
                                                expanded={
                                                  expandedPlaylist ===
                                                  playlist.id
                                                }
                                                onChange={handlePlaylistChange({
                                                  playlistId: playlist.id,
                                                  year: season.seasonName,
                                                })}
                                                className="playlistAccordion"
                                              >
                                                <AccordionSummary
                                                  aria-controls={`panel${playlistIndex}-content`}
                                                  id={`panel${playlistIndex}-header`}
                                                >
                                                  <div className="d-flex-align-cent">
                                                    {expandedPlaylist ===
                                                    playlist.id ? (
                                                      <FaMinusSquare
                                                        className="mg-right-10"
                                                        style={{
                                                          color: "#13005A",
                                                        }}
                                                      />
                                                    ) : (
                                                      <FaPlusSquare
                                                        className="mg-right-10"
                                                        style={{
                                                          color: "#13005A",
                                                        }}
                                                      />
                                                    )}
                                                    {playlist.playlistName}
                                                  </div>
                                                </AccordionSummary>
                                                {loadPlaylist && (
                                                  <div
                                                    className={
                                                      styles.circularLoading
                                                    }
                                                  >
                                                    <CircularProgress
                                                      sx={{
                                                        fontSize: "10",
                                                        color: "#002244",
                                                      }}
                                                      disableShrink
                                                    />
                                                  </div>
                                                )}
                                                <AccordionDetails className="pd-left-10">
                                                  <div className="d-flex flex-direction-c">
                                                    {/* Display videos for each playlist */}
                                                    {sortArrayOfObject(
                                                      playlistsData[
                                                        playlist?.id
                                                      ]?.media || []
                                                    ).map((video, videoKey) => (
                                                      <div
                                                        className="d-flex-space-between w-100 gap-10"
                                                        key={video.id}
                                                      >
                                                        <div className="d-flex-align-cent gap-10">
                                                          <Checkbox
                                                            key={videoKey}
                                                            name={
                                                              video.eventMediaCategory
                                                            }
                                                            checked={selectedVideoPaths.some(
                                                              (data) =>
                                                                data.path ===
                                                                video.videoPath
                                                            )}
                                                            onClick={(e) => {
                                                              handleCheckBoxChange(
                                                                e.target
                                                                  .checked,
                                                                {
                                                                  id: video.id,
                                                                  year: season.seasonName,
                                                                  playListId:
                                                                    playlist.id,
                                                                  ...video,
                                                                  year: season?.seasonName,
                                                                  seasonType:
                                                                    OffSeason,
                                                                  eventType: "",
                                                                  eventName:
                                                                    event?.eventName,
                                                                  practiceName:
                                                                    practice?.practiceName,
                                                                  weekname: "",
                                                                  scheduleId:
                                                                    "",
                                                                  schoolId,
                                                                  seasonId:
                                                                    video
                                                                      ?.scheduleEvent
                                                                      ?.season
                                                                      ?.id,
                                                                }
                                                              );
                                                              playVideo(
                                                                video.videoPath,
                                                                video.id
                                                              );
                                                            }}
                                                            icon={
                                                              <BsSquare
                                                                fontSize="20px"
                                                                color="#13005A"
                                                              />
                                                            }
                                                            checkedIcon={
                                                              <BsCheckSquare
                                                                fontSize="20px"
                                                                color="#13005A"
                                                              />
                                                            }
                                                            className="videolibrary-checkbox-icon"
                                                          />
                                                          <div className="oflow-hidden w-100">
                                                            <p>
                                                              {
                                                                video?.eventMediaCategory
                                                              }
                                                            </p>
                                                          </div>
                                                        </div>
                                                        {selectedVideoPaths.some(
                                                          (data) =>
                                                            data.path ===
                                                            video.videoPath
                                                        ) && (
                                                          <span>
                                                            <ShareVideo
                                                              eventMediaId={
                                                                video.id
                                                              }
                                                              playlistId={
                                                                playlistId
                                                              }
                                                              videoPath={
                                                                video.videoPath
                                                              }
                                                              videoName={
                                                                video.eventMediaCategory
                                                              }
                                                              videoData={video}
                                                              seasonType={
                                                                offSeason
                                                              }
                                                              offSeasonEventName={
                                                                event.eventName
                                                              }
                                                              practiceName={
                                                                practice.practiceName
                                                              }
                                                              setVideoName={(
                                                                params
                                                              ) =>
                                                                setVideoName(
                                                                  params
                                                                )
                                                              }
                                                              seasonName={
                                                                season.seasonName
                                                              }
                                                              selectedVideoPaths={
                                                                selectedVideoPaths
                                                              }
                                                              setVideoPath={
                                                                setVideoPath
                                                              }
                                                            />
                                                          </span>
                                                        )}
                                                      </div>
                                                    ))}
                                                    {playlistsData[playlist.id]
                                                      ?.media === 0 && (
                                                      <p>No Videos Found</p>
                                                    )}
                                                  </div>
                                                </AccordionDetails>
                                              </Accordion>
                                            ))
                                          ) : (
                                            <p>No Playlists Found</p>
                                          )}
                                        </div>
                                      </AccordionDetails>
                                    </Accordion>
                                  ))}
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={eventExpanded === Other}
                      onChange={handleEventChange(Other)}
                      className="subEvents accordion-container-border"
                      sx={{ cursor: "pointer !important" }}
                    >
                      <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        className="subEventsSummary"
                        sx={{ cursor: "pointer !important" }}
                      >
                        <div className="d-flex-align-cent">
                          {eventExpanded === Other ? (
                            <FaMinusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          ) : (
                            <FaPlusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          )}
                          Other
                        </div>
                      </AccordionSummary>
                      <AccordionDetails sx={{ cursor: "pointer !important" }}>
                        <Typography
                          sx={{
                            width: "33%",
                            flexShrink: 0,
                            cursor: "pointer !important",
                          }}
                          className="mg-top-min-20 eventText"
                        >
                          {season?.otherSeasonPlaylist?.map((item, index) => (
                            <Accordion
                              expanded={
                                otherSeasonTypeExpanded === item.seasonType
                              }
                              onChange={handleOtherSeasonTypeChange(
                                item.seasonType
                              )}
                              className="eventsWrapper accordion-container-border"
                              key={index}
                              sx={{ cursor: "pointer !important" }}
                            >
                              <AccordionSummary
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className="subEventsSummary"
                                sx={{ cursor: "pointer !important" }}
                              >
                                <div className="d-flex-align-cent">
                                  {otherSeasonTypeExpanded ===
                                  item.seasonType ? (
                                    <FaMinusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  ) : (
                                    <FaPlusSquare
                                      className="mg-right-10"
                                      style={{ color: "#13005A" }}
                                    />
                                  )}
                                  {item.seasonType}
                                </div>
                              </AccordionSummary>
                              <AccordionDetails
                                className="pd-left-25"
                                sx={{ cursor: "pointer !important" }}
                              >
                                <div className="d-flex flex-direction-c">
                                  {/* Loop through playlists */}
                                  {sortArrayOfObject(item.arrData).map(
                                    (playlist, key) => (
                                      <Accordion
                                        key={key}
                                        expanded={
                                          expandedPlaylist === playlist.id
                                        }
                                        onChange={handlePlaylistChange({
                                          playlistId: playlist.id,
                                          year: season.seasonName,
                                        })}
                                        className="playlistAccordion"
                                        sx={{ cursor: "pointer !important" }}
                                      >
                                        <AccordionSummary
                                          aria-controls={`panel${key}-content`}
                                          id={`panel${key}-header`}
                                        >
                                          <div className="d-flex-align-cent">
                                            {expandedPlaylist ===
                                            playlist.id ? (
                                              <FaMinusSquare
                                                className="mg-right-10"
                                                style={{ color: "#13005A" }}
                                              />
                                            ) : (
                                              <FaPlusSquare
                                                className="mg-right-10"
                                                style={{ color: "#13005A" }}
                                              />
                                            )}
                                            {playlist?.playlistName}
                                          </div>
                                        </AccordionSummary>
                                        {loadPlaylist && (
                                          <div
                                            className={styles.circularLoading}
                                          >
                                            <CircularProgress
                                              sx={{
                                                fontSize: "10",
                                                color: "#002244",
                                              }}
                                              disableShrink
                                            />
                                          </div>
                                        )}
                                        <AccordionDetails className="pd-left-10">
                                          <div className="d-flex flex-direction-c">
                                            {/* Loop through the videos inside each playlist */}
                                            {sortArrayOfObject(
                                              playlistsData[playlist.id]
                                                ?.media || []
                                            ).map((video, videoKey) => (
                                              <div
                                                className="d-flex-space-between w-100 gap-10"
                                                key={videoKey}
                                              >
                                                <div
                                                  className={`eventMediaInput ${
                                                    video.checked
                                                      ? "eventInputWidth"
                                                      : "w-100"
                                                  }`}
                                                >
                                                  <Checkbox
                                                    name={
                                                      video.eventMediaCategory
                                                    }
                                                    checked={selectedVideoPaths.some(
                                                      (data) =>
                                                        data.path ===
                                                        video.videoPath
                                                    )}
                                                    onClick={(e) => {
                                                      handleCheckBoxChange(
                                                        e.target.checked,
                                                        {
                                                          id: video.id,
                                                          year: season.seasonName,
                                                          playListId:
                                                            playlist.id,
                                                          ...video,
                                                          year: season?.seasonName,
                                                          seasonType: Other,
                                                          eventType: "",
                                                          eventName:
                                                            video?.scheduleEvent
                                                              .eventName,
                                                          practiceName: "",
                                                          weekname: "",
                                                          scheduleId: "",
                                                          schoolId,
                                                          seasonId:
                                                            video.scheduleEvent
                                                              .season.id,
                                                        }
                                                      );
                                                      isPlaylistSelected();
                                                      playVideo(
                                                        video.videoPath,
                                                        video.id
                                                      );
                                                    }}
                                                    icon={
                                                      <BsSquare
                                                        fontSize="20px"
                                                        color="#13005A"
                                                      />
                                                    }
                                                    checkedIcon={
                                                      <BsCheckSquare
                                                        fontSize="20px"
                                                        color="#13005A"
                                                      />
                                                    }
                                                    className="videolibrary-checkbox-icon"
                                                  />
                                                  <div className="oflow-hidden w-100">
                                                    <p
                                                      className={`${styles.videoNameWidth}`}
                                                    >
                                                      {video.eventMediaCategory}
                                                    </p>
                                                  </div>
                                                </div>
                                                {selectedVideoPaths.some(
                                                  (data) =>
                                                    data.path == video.videoPath
                                                ) && (
                                                  <ShareVideo
                                                    eventId={eventId}
                                                    eventMediaId={video?.id}
                                                    videoPath={video?.videoPath}
                                                    playlistId={playlistId}
                                                    videoName={
                                                      video?.eventMediaCategory
                                                    }
                                                    videoData={video}
                                                    seasonType={other}
                                                    otherSeasonEventType={
                                                      item.seasonType
                                                    }
                                                    setVideoName={(params) =>
                                                      setVideoName(params)
                                                    }
                                                    seasonName={
                                                      season.seasonName
                                                    }
                                                    selectedVideoPaths={
                                                      selectedVideoPaths
                                                    }
                                                    setVideoPath={setVideoPath}
                                                  />
                                                )}
                                              </div>
                                            ))}
                                            {playlistsData[playlist.id]
                                              ?.media === 0 && (
                                              <p>No Videos Found</p>
                                            )}
                                          </div>
                                        </AccordionDetails>
                                      </Accordion>
                                    )
                                  )}
                                  {item.arrData.length === 0 && (
                                    <div>
                                      <p>No Playlists Found</p>
                                    </div>
                                  )}
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={typeExpanded === highlight}
                      onChange={handleTypeChange(highlight)}
                      className="subEvents accordion-container-border"
                      sx={{ cursor: "pointer !important" }}
                    >
                      <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        className="subEventsSummary"
                        sx={{ cursor: "pointer !important" }}
                      >
                        <div className="d-flex-align-cent">
                          {typeExpanded === "Highlight" ? (
                            <FaMinusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          ) : (
                            <FaPlusSquare
                              className="mg-right-10"
                              style={{ color: "#13005A" }}
                            />
                          )}
                          {`Highlight (${
                            playlistsData[playlistId]?.highlights?.length
                              ? playlistsData[playlistId]?.highlights?.length
                              : 0
                          })`}
                        </div>
                      </AccordionSummary>
                      {loadPlaylist && (
                        <div className={styles.circularLoading}>
                          <CircularProgress
                            sx={{
                              fontSize: "10",
                              color: "#002244",
                            }}
                            disableShrink
                          />
                        </div>
                      )}
                      <AccordionDetails
                        className="pd-left-25"
                        sx={{ cursor: "pointer !important" }}
                      >
                        <div className="d-flex flex-direction-c">
                          {playlistId &&
                            sortArrayOfObject(
                              playlistsData[playlistId]?.highlights
                            )?.map((video, key) => (
                              <div
                                className="d-flex-space-between gap-5"
                                key={key}
                              >
                                <div className="d-flex-align-cent gap-10">
                                  <Checkbox
                                    name={video.eventMediaCategory}
                                    checked={selectedVideoPaths.some(
                                      (data) => video.videoPath == data.path
                                    )}
                                    onClick={(e) => {
                                      handleCheckBoxChange(e.target.checked, {
                                        id: video.id,
                                        year: season.seasonName,
                                        playListId: playlistId,
                                        ...video,
                                        seasonType:
                                          video?.scheduleEvent?.seasonType,
                                        eventType:
                                          video?.scheduleEvent?.seasonType ==
                                          InSeason
                                            ? video?.scheduleEvent?.eventType
                                            : "",
                                        eventName:
                                          video?.scheduleEvent?.seasonType ==
                                          InSeason
                                            ? ""
                                            : video?.scheduleEvent?.eventName,
                                        practiceName:
                                          video?.scheduleEvent?.seasonType ==
                                          OffSeason
                                            ? video?.scheduleEvent?.practiceName
                                            : "",
                                        scheduleId:
                                          video?.scheduleEvent?.seasonType ==
                                          InSeason
                                            ? video?.scheduleEvent?.schedule.id
                                            : "",
                                        schoolId,
                                        seasonId: video.scheduleEvent.season.id,
                                      });
                                    }}
                                    icon={
                                      <BsSquare
                                        fontSize="20px"
                                        color="#13005A"
                                      />
                                    }
                                    checkedIcon={
                                      <BsCheckSquare
                                        fontSize="20px"
                                        color="#13005A"
                                      />
                                    }
                                    className="videolibrary-checkbox-icon"
                                  />
                                  <div className="oflow-hidden w-100">
                                    <p className={`${styles.videoNameWidth}`}>
                                      {video.eventMediaCategory}
                                    </p>
                                  </div>
                                </div>
                                {selectedVideoPaths.some(
                                  (data) => data.path == video?.videoPath
                                ) && (
                                  <ShareVideo
                                    eventMediaId={video?.id}
                                    videoPath={video?.videoPath}
                                    videoName={video?.eventMediaCategory}
                                    videoData={video}
                                    playlistId={playlistId}
                                    seasonType={
                                      video?.scheduleEvent?.seasonType ===
                                      InSeason
                                        ? inSeason
                                        : video?.scheduleEvent?.seasonType ===
                                          OffSeason
                                        ? offSeason
                                        : video?.scheduleEvent?.seasonType ===
                                          Other
                                        ? other
                                        : ""
                                    }
                                    offSeasonEventName={
                                      video?.scheduleEvent?.eventName
                                    }
                                    otherSeasonEventType={
                                      video.scheduleEvent?.eventName
                                    }
                                    practiceName={
                                      video?.scheduleEvent?.practiceName
                                    }
                                    weekName={
                                      video.weekName ? video.weekName : ""
                                    }
                                    eventType={video.scheduleEvent?.eventType}
                                    setVideoName={(params) =>
                                      setVideoName(params)
                                    }
                                    seasonName={
                                      video.scheduleEvent?.season?.years
                                    }
                                    isVideoFromHighlight={true}
                                    selectedVideoPaths={selectedVideoPaths}
                                    setVideoPath={setVideoPath}
                                  />
                                )}
                              </div>
                            ))}
                          {playlistsData[playlistId]?.highlights
                            .length ? null : (
                            <p>No Videos Found</p>
                          )}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
